import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import { ICONS } from '../../../../../icons';
import Icon from '../../../../../icons/Icon';
import CommonButton from '../../../../../components/common-button/CommonButton';

import scss from '../SonarDatasetModal.module.scss';

const SocialFieldWrapper = ({ children, label, fieldKey, isShowError, errorText, onCrawl, disabled }) => {
  const { t } = useTranslation('projects');

  const { input } = useField(fieldKey);
  const crawledUrls = useSelector((state) => state.createSonar.crawledUrls);
  const [crawledUrl, setCrawledUrl] = useState('');

  const handleCrawlUrl = () => {
    if (onCrawl && fieldKey) {
      onCrawl(fieldKey);
    }
  };

  const handleAdd = () => {
    input.onChange(input.value + ', ' + crawledUrl);
    setCrawledUrl('');
  };

  const handleReplace = () => {
    input.onChange(crawledUrl);
    setCrawledUrl('');
  };

  useEffect(() => {
    if (!crawledUrls[fieldKey]) {
      return;
    }

    const crawledUrl = crawledUrls[fieldKey];

    if (!input.value) {
      input.onChange(crawledUrl);
      return;
    }

    const listOfUrls = input.value?.split(',') || [];
    const formattedListOfUrls = listOfUrls.map((url) => url.trim());

    if (input.value !== crawledUrl && !formattedListOfUrls.includes(crawledUrl)) {
      setCrawledUrl(crawledUrl);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [crawledUrls, fieldKey]);

  return (
    <div className={scss.socialFieldWrapper}>
      <WithLabel label={label} variant={LABEL_STYLES.CUSTOM} isBold extraClassName={scss.generalSectionField}>
        <div className={scss.generalSectionFieldContent}>{children}</div>
        <CommonButton styleColor='secondary' maxWidth={120} onClick={handleCrawlUrl} isStrokeIcon disabled={disabled}>
          <Icon icon={ICONS.Scan} /> {t('crawl')}
        </CommonButton>
        {isShowError ? (
          <div className={scss.generalSectionFieldError}>
            <Icon icon={ICONS.Info} disableCommonColors className={scss.errorIcon} />
            {errorText}
          </div>
        ) : null}
      </WithLabel>
      {crawledUrl ? (
        <WithLabel
          label={`${t('crawledUrl')}:`}
          variant={LABEL_STYLES.CUSTOM}
          isBold
          extraClassName={scss.generalSectionField}>
          <a className={scss.foundedUrl} href={crawledUrl} target='_blank' rel='noreferrer'>
            {crawledUrl}
          </a>

          <CommonButton styleColor='secondary' maxWidth={120} onClick={handleAdd}>
            {t('add')}
          </CommonButton>
          <CommonButton styleColor='primary' maxWidth={120} onClick={handleReplace}>
            {t('replace')}
          </CommonButton>
        </WithLabel>
      ) : null}
    </div>
  );
};

export default SocialFieldWrapper;
